export const Icons = {
  Twitter: "twitter",
  Download: "download",
  Image: "image",
  Arrow: "arrow",
  Search: "search",
  Info: "info",
  Exchange: "exchange",
  Refresh: "refresh"
}
